import Vue from 'vue'
import Flickity from 'vue-flickity'

Vue.component('Flickity', Flickity)
Vue.component('component-observer', require('./components/ComponentObserver.vue').default)
Vue.component('front-blog', require('./components/frontpage/FrontBlog.vue').default)
Vue.component('front-reviews', require('./components/frontpage/FrontReviews.vue').default)
Vue.component('front-selection', require('./components/frontpage/FrontSelection.vue').default)
Vue.component('front-faq', require('./components/frontpage/FrontFaq.vue').default)

const frontPageElement = document.getElementById('front-page')
if (frontPageElement) {
  new Vue({
    name: 'FrontPage',
    el: frontPageElement
  })
}
